import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  ref: "refRoot",
  class: "popup popup-tablet-fullscreen popup-sty-modal popup-showcase",
  id: "popup-light_commercial"
};
var _hoisted_2 = {
  class: "view"
};
var _hoisted_3 = {
  class: "page"
};
var _hoisted_4 = {
  class: "page-content popup-modal-centered"
};
var _hoisted_5 = {
  class: "popup-modal-content no-bg"
};
var _hoisted_6 = {
  class: "popup-showcase__foot"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 今日不再顯示 ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 關閉 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BaseImg = _resolveComponent("BaseImg");

  var _component_f7_swiper_slide = _resolveComponent("f7-swiper-slide");

  var _component_f7_swiper = _resolveComponent("f7-swiper");

  var _component_f7_button = _resolveComponent("f7-button");

  var _component_f7_col = _resolveComponent("f7-col");

  var _component_f7_row = _resolveComponent("f7-row");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createVNode("div", _hoisted_5, [_createVNode(_component_f7_swiper, {
    style: {
      "width": "100%"
    },
    onSwiper: $options.onSwiper,
    onAfterInit: $options.onAfterInit,
    navigation: "",
    pagination: "",
    spaceBetween: 0,
    slidesPerView: 1,
    autoplay: {
      delay: 8000
    }
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createBlock(_Fragment, null, _renderList($data.cData.list, function (item, idx) {
        return _openBlock(), _createBlock(_component_f7_swiper_slide, {
          key: idx
        }, {
          default: _withCtx(function () {
            return [_createVNode("a", {
              class: "popup-showcase__img-wrap",
              onClick: function onClick($event) {
                return $options.openLink(item.url_link, item.open_type);
              }
            }, [_createVNode(_component_BaseImg, {
              src: item.pic_src
            }, null, 8, ["src"])], 8, ["onClick"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["onSwiper", "onAfterInit"]), _createVNode("div", _hoisted_6, [_createVNode(_component_f7_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_f7_col, {
        width: "50"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_button, {
            type: "button",
            class: "btn-sec size-h-40px btn-radius-pill",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return $options.dontShowToday();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_f7_col, {
        width: "50"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_button, {
            type: "button",
            class: "btn-theme size-h-40px btn-radius-pill popup-close",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return $options.dontShowThisLogin();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  })])])])])])], 512);
}